import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'vehicle-error',
  styleUrl: 'vehicle-error.css',
})
export class VehicleError {
  @Prop() errorTitle: string = '';
  @Prop() errorMessage: string = '';

  render() {
    return (
      <div class="bg-red-50 border border-red-300 rounded-lg p-4 flex items-start gap-3 mt-3">
        <svg-icon icon="warning-icon" width="24" height="24" class="text-red-600 flex-shrink-0 mt-0.5"></svg-icon>
        <div class="flex-1 font-montserrat">
          <h2 class="text-lg font-extrabold text-red-600 mb-2">{this.errorTitle}</h2>
          <span class="text-sm text-red-700 leading-relaxed">{this.errorMessage}</span>
        </div>
      </div>
    );
  }
}
